import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from "vue-property-decorator";
import { FormControlType, } from "@cloudpivot/form/schema";
let HLabel = class HLabel extends Vue {
    get isGroup() {
        return this.control && this.control.type === FormControlType.Group;
    }
    get isDescription() {
        return this.control && this.control.type === FormControlType.Description;
    }
    get label() {
        if (!this.control || !this.control.options) {
            return this.text;
        }
        let name = this.control.options.name;
        const name_i18n = this.control.options.name_i18n;
        if (name_i18n) {
            // const map = JSON.parse(name_i18n);
            const map = name_i18n;
            const locale = this.$i18n.locale;
            if (map[locale]) {
                name = map[locale];
            }
        }
        return name;
    }
    created() {
        console.log(this.control);
    }
};
tslib_1.__decorate([
    Prop()
], HLabel.prototype, "control", void 0);
tslib_1.__decorate([
    Prop({ default: '' })
], HLabel.prototype, "text", void 0);
HLabel = tslib_1.__decorate([
    Component({
        name: 'h-label'
    })
], HLabel);
export default HLabel;
